import { call, put, takeEvery } from "redux-saga/effects";
import {
    EKYC_SESSION, ekycSession,
    EKYC_RESULT, ekycResult,
    EKYC_DELEGATE, ekycDelegate,
} from "module/ekycModule";
import { LOGOUT } from "module/userModule";

function* EkycSaga() {
    yield takeEvery(EKYC_SESSION.POST.REQUEST, createSession);
    yield takeEvery(EKYC_RESULT.POST.REQUEST, saveResult);
    yield takeEvery(EKYC_DELEGATE.GET.REQUEST, getDelegation);
}

// UseB 세션 생성 — 백엔드가 transaction_id + access_token 발급
function _createSessionAPI(payload) {
    return new Promise((resolve, reject) => {
        try {
            fetch("/api/v1/ekyc/session", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${payload.token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    I_ETMTSEQ: payload.estimate,
                    I_VBELN: payload.vbeln,
                    I_KUNNR: payload.kunnr,
                    I_KATR7: payload.katr7,
                    authType: payload.authType, // "personal" | "corp_rep" | "corp_delegate"
                }),
            })
                .then((response) => {
                    if (response.status === 401) {
                        resolve(response.status);
                    } else if (response.status === 400) {
                        resolve("BAD_REQUEST");
                    } else if (response.status === 200) {
                        resolve(response.json());
                    } else {
                        resolve(null);
                    }
                })
                .catch((error) => reject(error));
        } catch (e) {
            reject(e);
        }
    });
}

function* createSession(action) {
    try {
        const response = yield call(_createSessionAPI, action.payload);
        if (response === 401) {
            yield put({ type: LOGOUT.POST.SUCCESS });
        } else if (response === "BAD_REQUEST") {
            yield put({ type: EKYC_SESSION.POST.FAIL, payload: { errorCode: "DATA_ERROR" } });
        } else if (response && response.errorCode) {
            // SAP MSGNR=999 누락 에러: errorCode="FIELD_MISSING", fieldLabel=누락 항목명
            yield put({ type: EKYC_SESSION.POST.FAIL, payload: { errorCode: response.errorCode, fieldLabel: response.fieldLabel || "" } });
        } else if (response) {
            yield put({ type: EKYC_SESSION.POST.SUCCESS, payload: response });
        } else {
            yield put(ekycSession.post.fail());
        }
    } catch (e) {
        yield put(ekycSession.post.fail());
    }
}


// postMessage 수신 결과를 백엔드에 저장
function _saveResultAPI(payload) {
    return new Promise((resolve, reject) => {
        try {
            fetch("/api/v1/ekyc/result", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${payload.token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    I_ETMTSEQ: payload.estimate,
                    transactionId: payload.transactionId,
                    result: payload.result,
                    ekycId: payload.ekycId,
                    resultType: payload.resultType,
                }),
            })
                .then((response) => {
                    if (response.status === 401 || response.status === 400) {
                        resolve(response.status);
                    } else if (response.status === 200) {
                        resolve(response.json());
                    } else {
                        resolve(null);
                    }
                })
                .catch((error) => reject(error));
        } catch (e) {
            reject(e);
        }
    });
}
function* saveResult(action) {
    try {
        const response = yield call(_saveResultAPI, action.payload);
        if (response === 401) {
            yield put({ type: LOGOUT.POST.SUCCESS });
        } else if (response === 400) {
            yield put({ type: LOGOUT.GET.SUCCESS });
        } else if (response) {
            yield put({
                type: EKYC_RESULT.POST.SUCCESS,
                payload: {
                    resultType: action.payload.resultType,
                },
            });
        } else {
            yield put(ekycResult.post.fail());
        }
    } catch (e) {
        yield put(ekycResult.post.fail());
    }
}

function _getDelegationAPI(payload) {
    return new Promise((resolve, reject) => {
        try {
            const identifier = payload.vbeln || payload.estimate;
            const params = new URLSearchParams();
            if (payload.vbeln)  params.append("vbeln", payload.vbeln);
            params.append("successorGubun", payload.successorGubun || "");
            if (payload.isMid)  params.append("isMid", "true");
            const query = params.toString() ? `?${params.toString()}` : "";

            fetch(`/api/v1/ekyc/delegation/${identifier}${query}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${payload.token}`,
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (response.status === 401 || response.status === 400) {
                        resolve(response.status);
                    } else if (response.status === 200) {
                        resolve(response.json());
                    } else {
                        resolve(null);
                    }
                })
                .catch((error) => reject(error));
        } catch (e) {
            reject(e);
        }
    });
}
function* getDelegation(action) {
    try {
        const response = yield call(_getDelegationAPI, action.payload);
        if (response === 401) {
            yield put({ type: LOGOUT.POST.SUCCESS });
        } else if (response === 400) {
            yield put({ type: LOGOUT.GET.SUCCESS });
        } else if (response) {
            yield put({ type: EKYC_DELEGATE.GET.SUCCESS, payload: response });
        } else {
            yield put(ekycDelegate.get.fail());
        }
    } catch (e) {
        yield put(ekycDelegate.get.fail());
    }
}

export default EkycSaga;
